import qs from "querystring";

export function parseQuerystring(location) {
    return qs.parse(location.search.replace(/^\?/, ''));
}

export function getStateFromQuerystring(queryString) {
    const diffs = queryString.diffs || "";
    const httpStatus = queryString.httpStatus || "";
    const isRegexFilter = queryString.uriSearch?.includes("isRegex:true") || false;
    const hasRedirectChain = !!queryString.redirectChain;

    const crawlScope = (queryString.crawlScope || "").toLowerCase();
    const reasonsCSV = (queryString.notIndexableReasons || "").toString();
    const reasons = reasonsCSV.length ? reasonsCSV.split(",") : [];

    return {
        isRegexFilter: isRegexFilter,
        uriSearch: getUriSearch(queryString) || "",
        toggles: {
            titleChecked: diffs.includes("Title"),
            metaChecked: diffs.includes("Meta"),
            h1Checked: diffs.includes("H1"),
            h2Checked: diffs.includes("H2"),
            redirectChecked: diffs.includes("Redirect"),
            just200Checked: hasRedirectChain,
            longRedirectChainChecked: queryString.longRedirectChain === "true",
            status200Checked: httpStatus.includes("200"),
            status301Checked: httpStatus.includes("301"),
            status3xxChecked: httpStatus.includes("302"),
            status4xxChecked: httpStatus.includes("404"),
            status5xxChecked: httpStatus.includes("500"),

            // Crawl scope
            crawlInternalChecked: crawlScope === "internal",
            crawlExternalChecked: crawlScope === "external",

            // Indexability reasons
            reasonCanonicalizedChecked: reasons.includes("CANONICALIZED"),
            reasonMetaNoindexChecked: reasons.includes("META_NOINDEX"),
            reasonRobotsTxtChecked: reasons.includes("BLOCKED_BY_ROBOTS_TXT"),
            reasonXRobotsNoindexChecked: reasons.includes("X_ROBOTS_NOINDEX"),

            // Discoverability
            isOrphanChecked: queryString.isOrphan === "true",
            isMissingInSitemapChecked: queryString.missingInSitemap === "true",
            isMissingInCrawlChecked: queryString.missingInCrawl === "true",
            isDiscoverableChecked: queryString.isDiscoverable === "true",
        }
    }
}

function getUriSearch(curQueryString) {
    const queryMatch = curQueryString.uriSearch?.match(/query:([^|]+)/);
    return queryMatch ? queryMatch[1] : "";
}

export function resolvePath(from, to) {
    const resolvedURL = new URL(to, 'http://dummyhost' + from).href;
    return resolvedURL.replace('http://dummyhost', '');
}
